import React from "react";
import PropTypes from "prop-types";
import { Upload,Icon } from "antd";
// import { MessageOutlined } from "@ant-design/icons";
import { getAuthToken } from "utilities/auth";

const { Dragger } = Upload;

class DraggableUploader extends React.Component {
    state = {
        visible: false
    };
    onFileUploadStatusChange = ({ file }) => {
        if (file.status === "done"){
            this.props.onChange(
                this.props.multiple
                    ?
                    this.props.value.push({
                        ...file.response,
                        name: file.response.file.split("/").reverse()[0]
                    })
                    : {
                        ...file.response,
                        name: file.response.file.split("/").reverse()[0]
                    }
            );
            this.props.onFileUploadComplete();
        }
    };
    viewDocument = () => {
        this.setState({
            visible: !this.state.visible
        });
    };
    render() {
        return (
            <React.Fragment>
                <Dragger
                    name={"file"}
                    showUploadList={false}
                    // action={this.props.uploadTarget}
                    accept={this.props.accept}
                    multiple={this.props.multiple}
                    className={"bg-white"}
                    onChange={this.onFileUploadStatusChange}
                    onPreview={this.props.showPreview ? this.handlePreview : null}
                    action={this.props.action}
                    onRemove={this.props.onRemove}
                    beforeUpload={this.props.beforeUpload}
                    data={file => {
                        return {
                            ...this.props.params,
                            file_name: file.name
                        };
                    }}
                    headers={{
                        Authorization: `Bearer ${getAuthToken().authToken}`
                    }}
                >
                    <p className="ant-upload-text">
                        {this.props.title}
                    </p>
                    <p className="ant-upload-hint">
                        {this.props.subtitle}
                    </p>
                </Dragger>
                {this.props.value?.map(el=> {
                    return(
                        <div key={el} className="d-flex justify-content-space-between align-items-center">
                            <span> {el.name} </span>
                            <Icon type="delete" onClick={()=>this.props.onRemove(el)}/>
                        </div>
                    );})}
            </React.Fragment>
        );
    }
}

DraggableUploader.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    onFileUploadComplete: PropTypes.func,
    accept: PropTypes.string,
    uploadTarget: PropTypes.string,
    viewable: PropTypes.bool,
    params: PropTypes.object,
    multiple: PropTypes.bool,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    showPreview: PropTypes.bool,
    beforeUpload: PropTypes.func,
    action: PropTypes.string,
    onRemove: PropTypes.func
};

DraggableUploader.defaultProps = {
    multiple: false,
    showPreview: false
};

export default DraggableUploader;
